import Button from '_atoms/Button/Button';
import InputBox from '_atoms/InputBox';
import useNavigate from 'Hooks/useNavigate';
import OnboardingBasePage from 'Pages/Common/Onboarding/OnboardingBasePage';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import './preauthPages.scss';

const NameQuestionScreen: React.FC = () => {
    const [name, setName] = useState('');
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { country, language } = useLocation().state || {};

    // Handle user opening "/register/name" without state. Redirect to auth for user to choose create user or login
    useEffect(() => {
        if (!country || !language) {
            navigate('/auth');
        }
    }, [country, language]);

    return (
        <OnboardingBasePage
            showBackButton={true}
            header={t('What is your name?')}
            className="min-height-screen"
        >
            <div className="preauth-page-wrapper">
                <div className="preauth-page-content name-question-screen">
                    <InputBox
                        id="name"
                        type="text"
                        label="First name"
                        placeholder="First name"
                        value={name}
                        handleChange={(e) => setName(e.target.value)}
                        autoFocus={true}
                    />
                    <Button
                        classes="submit-name"
                        onClick={() => {
                            navigate('/register/email', {
                                state: { country, language, name },
                            });
                        }}
                        isDisabled={!name}
                    >
                        {t('Continue')}
                    </Button>
                </div>
            </div>
        </OnboardingBasePage>
    );
};

export default NameQuestionScreen;
